module.exports = __webpack_public_path__ + "media/customizations/amblebrook/logo-6dbb83a3a14d224be43c4935b4bd30b3.png";